import { UserInfo } from '@Entities/user/user'
import { getFullPhoneNumberTitle } from '@App/helpers/get-phone-number-title'

const getPhoneNumberDisplay = (userInfo: UserInfo) => {
    const { phoneCountryCode, fullPhoneNumber } = userInfo
    return getFullPhoneNumberTitle(phoneCountryCode, fullPhoneNumber)
}
export default getPhoneNumberDisplay
